class CustomPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    const trigger = this.querySelector('[data-open-popup="btnOpen"]');
    if (trigger) {
      trigger.addEventListener("click", () => this.open());
    }

    const closeBtn = this.querySelector('[data-button-close="close"]');
    if (closeBtn) {
      closeBtn.addEventListener("click", () => this.close());
    }

    const overlay = this.querySelector(".overlay");
    if (overlay) {
      overlay.addEventListener("click", (e) => {
        if (e.target === overlay) this.close();
      });
    }
  }

  open() {
    const overlay = this.querySelector(".overlay");
    if (overlay) {
      overlay.classList.add("show");
      document.body.style.overflow = "hidden";
    }
  }

  close() {
    const overlay = this.querySelector(".overlay");
    if (overlay) {
      overlay.classList.remove("show");
      document.body.style.overflow = "";
    }
  }
}

customElements.define("custom-popup", CustomPopup);
